import React, { useMemo, useState } from "react";
import { Files, Hospital, ShieldCheck } from "lucide-react";

import { SidebarMenu } from "components/ui/SidebarMenu";
import {
  DEASP_LABEL,
  isDeaspDocumentType,
} from "features/documents/utils/deaspDocumentType";
import {
  DISCHARGE_SUMMARIES_LABEL,
  DISCHARGE_SUMMARIES_MENU_VALUE,
} from "features/documents/utils/dischargeSummary";
import { formatDocumentTypeLabel, getDocumentTypeIcon } from "utils/documentTypeIcons";

const ALL_LABEL = "All Documents";
const DEASP_MENU_VALUE = "DEASP";

const DocumentMenu = ({ menuClick, documentTypes = [] }) => {
  const [activeLabel, setActiveLabel] = useState(ALL_LABEL);

  const items = useMemo(
    () => [
      {
        label: ALL_LABEL,
        Icon: Files,
        onClick: () => {
          setActiveLabel(ALL_LABEL);
          menuClick("ALL");
        },
      },
      /*
       * Not one of the API's document types — discharge summaries arrive as HL7 messages, not as
       * uploads, so nothing in `documentTypes` describes them. Injected here the way DEASP is,
       * which is the precedent for a message-type-driven section on this screen (KIN-2028).
       */
      {
        label: DISCHARGE_SUMMARIES_LABEL,
        Icon: Hospital,
        onClick: () => {
          setActiveLabel(DISCHARGE_SUMMARIES_LABEL);
          menuClick(DISCHARGE_SUMMARIES_MENU_VALUE);
        },
      },
      ...documentTypes.map((documentType) => {
        if (isDeaspDocumentType(documentType)) {
          return {
            label: DEASP_LABEL,
            Icon: ShieldCheck,
            onClick: () => {
              setActiveLabel(DEASP_LABEL);
              menuClick(DEASP_MENU_VALUE);
            },
          };
        }

        const label =
          documentType.label || formatDocumentTypeLabel(documentType.name);
        return {
          label,
          Icon: getDocumentTypeIcon(documentType.name, documentType.icon),
          onClick: () => {
            setActiveLabel(label);
            menuClick(documentType.name.toUpperCase());
          },
        };
      }),
    ],
    [documentTypes, menuClick]
  );

  const resolvedActive = activeLabel || ALL_LABEL;

  return <SidebarMenu items={items} activeItem={resolvedActive} iconSize={18} />;
};

export { DocumentMenu };
